import { useContext } from 'react';

import { IconAngleLeft } from '@iwoca/icons';
import { Link, useLocation } from 'react-router';

import { buildQueryString } from '../../../utils/queryParams';
import { useNonLinearSecurityChecks } from '../../hooks/useNonLinearSecurityChecks.hook';
import { RouteContext } from '../../routes';

export const NonLinearSecurityChecksLayout = ({
  children,
  useLayout,
}: {
  children: React.ReactNode;
  useLayout: boolean;
}) => {
  const { steps } = useNonLinearSecurityChecks();
  const { basePath } = useContext(RouteContext);

  const securityStepRoutes = Object.entries(steps).map(
    ([stepName]) => `${basePath}/${stepName}/`,
  );
  const queryString = buildQueryString();
  const location = useLocation();

  const isSecurityStep = securityStepRoutes.includes(location.pathname);
  const SecurityCheckListUrl = `${basePath}/${queryString}`;

  return useLayout && isSecurityStep ? (
    <div className="[&>article]:rounded-t-[0px] [&>article]:border-t-white [&>article]:pt-0">
      <div className="rounded-t-l border border-b-0 border-secondary-90 bg-white p-xl pb-s">
        <Link
          to={SecurityCheckListUrl}
          className="m-0 flex h-[36px] items-center text-s font-bold text-primary-40 no-underline hover:cursor-pointer"
        >
          <IconAngleLeft className="size-l" /> Back to list
        </Link>
      </div>
      {children}
    </div>
  ) : (
    <>{children}</>
  );
};
